<template>
  <div>
    <section-wrapper>
      <div class="olympic active">
        <section class="olympic__header">
          <div class="olympic__header__text">
            <h1 class="text-danger">СТУДЕНЧЕСКАЯ ОНЛАЙН-ОЛИМПИАДА</h1>
            <h1 class="mt-2 content_60">«КАДРЫ ДЛЯ ЭКСПОРТА»</h1>
            <h2 class="mt-2 text-primary">Вторая волна — 2025</h2>
          </div>
          <div class="d-none d-lg-block olympic__header__img">
            <img title="МЕЖДУНАРОДНАЯ ОНЛАЙН-ОЛИМПИАДА" src="/pic/owl.png" />
          </div>
        </section>
        <section v-if="false" class="olympic__text mb-5">
          <button @click="showRegulationConfirm" class="link-target">РЕГИСТРАЦИЯ</button>
          <p class="content_22 mt-2">Регистрация открыта до 30 сентября 2025 года включительно!</p>
        </section>
        <section class="olympic__text mb-5">
          <h1 class="text-dark mb-2">Об Олимпиаде</h1>
          <p class="content_22 mb-2"><b>Олимпиада «Кадры для экспорта»</b> - это образовательное соревнование, которое помогает молодежи проверить свои знания в сфере внешнеэкономической деятельности.</p>
          <p class="content_22 mb-2">Участники смогут не только продемонстрировать свои знания и навыки, но и получить поддержку для дальнейшего профессионального развития!</p>
          <p class="content_22 mb-2"> Вторая волна посвящена одному из самых перспективных внешних рынков — Турции. Ты сможешь познакомиться с особенностями ведения бизнеса с турецкими партнёрами и освоить навыки, которые станут твоей конкурентной силой на международном рынке труда!</p>
          <p class="content_22 mb-2">Сроки проведения: 1-3 октября 2025.</p>
        </section>
        <section class="olympic__text mb-5">
          <h1 class="text-dark mb-2">Успешный старт: итоги первой волны</h1>
          <p class="content_22 mb-2">Первая волна Олимпиады прошла в 2024 году и объединила талантливую молодёжь из разных стран СНГ:</p>
          <ul class="content_22 mb-2">
            <li>322 заявки</li>
            <li>157 активных участников</li>
            <li>25 ведущих вузов из России, Беларуси и Кыргызстана</li>
          </ul>
        </section>
        <section class="olympic__text mb-5">
          <h1 class="text-dark mb-2">Почему стоит участвовать в этой Олимпиаде?</h1>
          <ul class="content_22 mb-2">
            <li>Проверь свои знания по ВЭД в интерактивном формате</li>
            <li>Стань частью активного сообщества единомышленников из России и стран СНГ</li>
            <li>Выиграй ценные призы — скидки на обучение на программах Школы экспорта РЭЦ до 99%!</li>
          </ul>
        </section>
        <section class="olympic__text mb-2">
          <div class="animated-container">
            <h1 class="text-dark mb-2">Кто может участвовать?</h1>
            <grid3-underline :items="[
              {title: 'Студенты бакалавриата', text: '4 курс и старше'},
              {title: 'Студенты магистратуры', text: '1–2 курс'},
              {title: 'Студенты ссузов', text: 'выпускные курсы'}
          ]" />
          </div>
        </section>
        <section class="olympic__text mb-2">
          <h1 class="text-dark mb-2">Расписание второй волны олимпиады — 2025</h1>
          <schedule :steps="steps" />
        </section>
        <section class="olympic__text mb-2">
          <button v-if="false" @click="showRegulationConfirm" class="mb-4 mt-4 link-target">РЕГИСТРАЦИЯ</button>

          <div class="container-grid grid-3 mb-4">
            <document title="Регламент олимпиады.pdf" link="//exporteduru.servicecdn.ru/media/default/0003/47/a6503dccb4a2c366d18eab4a8d82a52d64de6100.pdf" />
          </div>
        </section>
      </div>

      <!-- Модальные окна -->
      <olympics-regulation-confirm-modal
          v-model="showRegulationConfirmModal"
          @confirm="onRegulationConfirm"
          @cancel="onRegulationCancel"
      />

      <olympics-cancel-confirm-modal
          v-model="showCancelConfirmModal"
          @yes="onCancelConfirmYes"
          @no="onCancelConfirmNo"
      />

      <olympics-registration-form
          v-model="showRegistrationForm"
          @cancel="onRegistrationCancel"
          @success="onRegistrationSuccess"
      />

      <div v-if="showSuccessModal" class="modal olympic-modal letter fade show" style="display: block;" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <div class="title-with-icon">
                <div class="title-with-icon__icon title-with-icon__icon_login"></div>
                <div class="title-with-icon__title">
                  <span rel="letter" class="title-letter">Вам письмо!</span>
                </div>
              </div>
              <button type="button" class="close modal-close" @click="onSuccessOk" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <success-letter :email="successEmail" :title="successTitle" />
            </div>
          </div>
        </div>
      </div>
      <div v-if="showSuccessModal" class="modal-backdrop show"></div>

      <!-- Компоненты модальных окон -->
      <olympics-status-modal
          :show="showStartModal"
          :user-status="userStatus"
          :is-loading="isLoading"
          @close="onStartModalClose"
          @register="onStartModalRegister"
      />

      <olympics-start-modal
          :show="showOlympicsStartModal"
          :slides="olympicsSlides"
          @close="onOlympicsStartClose"
          @begin="onOlympicsStartBegin"
      />

      <olympics-step2-modal
          :show="showOlympicsStep2Modal"
          @close="onOlympicsStep2Close"
          @begin="onOlympicsStep2Begin"
      />

      <olympics-step3-modal
          :show="showOlympicsStep3Modal"
          @close="onOlympicsStep3Close"
          @begin="onOlympicsStep3Begin"
      />
    </section-wrapper>
    <page-footer/>
  </div>
</template>

<script>
import SectionWrapper from "@/components/SectionWrapper.vue";
import Schedule from "@/components/Schedule.vue";
import Grid3Underline from "@/components/Grid3Underline.vue";
import Document from "@/components/Document.vue";
import OlympicsRegulationConfirmModal from "@/components/olympics/OlympicsRegulationConfirmModal.vue";
import OlympicsCancelConfirmModal from "@/components/olympics/OlympicsCancelConfirmModal.vue";
import OlympicsRegistrationForm from "@/components/olympics/OlympicsRegistrationForm.vue";
import OlympicsStatusModal from "@/components/olympics/OlympicsStatusModal.vue";
import OlympicsStartModal from "@/components/olympics/OlympicsStartModal.vue";
import OlympicsStep2Modal from "@/components/olympics/OlympicsStep2Modal.vue";
import OlympicsStep3Modal from "@/components/olympics/OlympicsStep3Modal.vue";
import SuccessLetter from "@/components/SuccessLetter.vue";
import ApiService from "../../services/api.service";
import PageFooter from "@/components/PageFooter.vue";

export default {
  name: "Olympics",
  components: {
    PageFooter,
    Document, 
    Grid3Underline, 
    Schedule, 
    SectionWrapper,
    OlympicsRegulationConfirmModal,
    OlympicsCancelConfirmModal,
    OlympicsRegistrationForm,
    OlympicsStatusModal,
    OlympicsStartModal,
    OlympicsStep2Modal,
    OlympicsStep3Modal,
    SuccessLetter
  },
  data() {
    return {
      steps: [
        {title: '1 ШАГ: ЗАРЕГИСТРИРОВАТЬСЯ НА ОЛИМПИАДУ', text: 'Регистрация происходит на странице Олимпиады на сайте exportedu.ru <span class=\'text-danger\'>до 30 сентября 2025 года включительно!</span>'},
        {title: '2 ШАГ: РЕШИТЬ ЗАДАНИЯ ОЛИМПИАДЫ', text: "  <ul>\n" +
              "    <li>1 этап Олимпиады: поиск зарубежного контрагента <span class=\"text-danger\">с 1 октября 2025</span></li>\n" +
              "    <li>2 этап Олимпиады: переговоры и заключение контракта <span class=\"text-danger\">с 2 октября 2025</span></li>\n" +
              "    <li>3 этап Олимпиады: организация экспортной поставки <span class=\"text-danger\">с 3 октября 2025</span></li>\n" +
              "  </ul>"},
        {title: '3 ШАГ: УЗНАТЬ СВОЙ РЕЗУЛЬТАТ', text: 'Объявление итогов Олимпиады на онлайн-трансляции <span class=\'text-danger\'>6 октября 2025 года</span>'}
      ],
      showRegulationConfirmModal: false,
      showCancelConfirmModal: false,
      showRegistrationForm: false,
      showSuccessModal: false,
      successEmail: null,
      successTitle: 'Для завершения регистрации на олимпиаду Вам необходимо пройти по ссылке, которая направлена на адрес',
      showStartModal: false,
      userStatus: null, // 'authenticated', 'not_authenticated', 'has_application', 'no_application'
      isLoading: false,
      showOlympicsStartModal: false,
      showOlympicsStep2Modal: false,
      showOlympicsStep3Modal: false,
      olympicsSlides: [
        {
          title: 'Добро пожаловать на олимпиаду!',
          content: 'Вы готовы проверить свои знания в сфере внешнеэкономической деятельности?',
          image: '/pic/owl.png'
        },
        {
          title: '',
          content: 'Вы — новый сотрудник команды молодых и амбициозных специалистов в области внешнеэкономической деятельности (ВЭД) компании ООО «Здоровое питание». Компания уже 10 лет успешно экспортирует продукты питания.\n\nГенеральный директор поставил перед вами амбициозную задачу: вывести на новый для компании рынок — Турцию — флагманский продукт — подсолнечное масло. Этот продукт уже завоевал популярность в России, и теперь вам предстоит сделать его звездой на международной арене.\n\nВам предстоит проанализировать рынок, понять потребителя, оценить риски и подготовить основу для выхода.\n\nУдачи! Ваш профессионализм решает успех проекта.',
          image: '/pic/owl.png'
        },
        {
          title: '',
          content: 'Первый шаг! Вам необходимо заняться анализом рынка Турции.\n\nАнализ зарубежного рынка перед экспортом необходим для того, чтобы адаптировать продукт под требования потребителей, снизить риски и повысить шансы на успешный выход на рынок.',
          image: '/pic/owl.png'
        }
      ]
    }
  },
  mounted() {
    this.$parent.init()
    this.checkStartMode()
  },
  methods: {
    showRegulationConfirm() {
      this.showRegulationConfirmModal = true
    },
    onRegulationConfirm() {
      this.showRegulationConfirmModal = false
      this.showRegistrationForm = true
    },
    onRegulationCancel() {
      this.showRegulationConfirmModal = false
    },
    onRegistrationCancel() {
      this.showCancelConfirmModal = true
    },
    onCancelConfirmYes() {
      this.showCancelConfirmModal = false
      this.showRegistrationForm = false
    },
    onCancelConfirmNo() {
      this.showCancelConfirmModal = false
    },
    onRegistrationSuccess(formData) {
      this.showRegistrationForm = false
      this.successEmail = formData.email
      this.showSuccessModal = true
    },
    onSuccessOk() {
      this.showSuccessModal = false
    },
    async checkStartMode() {
      // Проверяем наличие GET параметра ?step=start
      if (this.$route.query.step === 'start') {
        // Сначала проверяем статус пользователя
        await this.checkOlympicsApplication()
      }
      // Проверяем наличие GET параметра ?step=second
      if (this.$route.query.step === 'second') {
        // Сначала проверяем статус пользователя
        await this.checkOlympicsApplication()
      }
      // Проверяем наличие GET параметра ?step=third
      if (this.$route.query.step === 'third') {
        // Сначала проверяем статус пользователя
        await this.checkOlympicsApplication()
      }
    },
    async checkOlympicsApplication() {
      try {
        console.log('Checking olympics application...')
        // Проверяем наличие заявки на олимпиаду через API
        const hasApplication = await this.checkUserApplication()
        console.log('Has application:', hasApplication)
        
        if (hasApplication) {
          this.userStatus = 'has_application'
          // Если пользователь зарегистрирован и есть параметр ?step=start, показываем слайдер
          if (this.$route.query.step === 'start') {
            this.showOlympicsStartModal = true
            this.currentSlide = 0
          } else if (this.$route.query.step === 'second') {
            this.showOlympicsStep2Modal = true
          } else if (this.$route.query.step === 'third') {
            this.showOlympicsStep3Modal = true
          } else {
            this.showStartModal = true
          }
        } else {
          this.userStatus = 'no_application'
          this.showStartModal = true
        }
      } catch (error) {
        console.error('Ошибка при проверке заявки:', error)
        this.userStatus = 'error'
        this.showStartModal = true
      }
    },
    async checkUserApplication() {
      try {
        const response = await ApiService.checkOlympicsUserStatus()
        console.log('API Response:', response.data)
        
        // Если API возвращает 200, но с сообщением о том, что пользователь не зарегистрирован
        if (response.data && response.data.message && response.data.message.includes('не зарегистрированы')) {
          return false
        }
        
        // Проверяем разные возможные поля в ответе
        return response.data.hasRegistration || response.data.registered || response.data.isRegistered || false
      } catch (error) {
        console.error('Ошибка при проверке заявки пользователя:', error)
        return false
      }
    },
    onStartModalClose() {
      this.showStartModal = false
    },
    onStartModalRegister() {
      this.showStartModal = false
      this.showRegulationConfirm()
    },
    onOlympicsStartClose() {
      this.showOlympicsStartModal = false
    },
    onOlympicsStartBegin() {
      this.showOlympicsStartModal = false
      // Переход на страницу теста через роутер
      this.$router.push('/lk/test/4271')
    },
    onOlympicsStep2Close() {
      this.showOlympicsStep2Modal = false
    },
    onOlympicsStep2Begin() {
      this.showOlympicsStep2Modal = false
      // Переход на страницу теста для второго этапа через роутер
      this.$router.push('/lk/test/4272')
    },
    onOlympicsStep3Close() {
      this.showOlympicsStep3Modal = false
    },
    onOlympicsStep3Begin() {
      this.showOlympicsStep3Modal = false
      // Переход на страницу теста для третьего этапа через роутер
      this.$router.push('/lk/test/4273')
    }
  }
}
</script>
<style>
.olympic-modal .modal-form {
  display: block!important;
}

</style>